export enum DepartmentEnum{
    Admins = 'ADMINS',
    AccountingSportEquipment = 'ACCOUNTING_SPORT_EQUIPMENT',
    PlanningAndOrganizationPaidServices = 'PLANNING_AND_ORGANIZATION_PAID_SERVICES',
    EquipmentAcceptanceAndDiagnostics = 'EQUIPMENT_ACCEPTANCE_AND_DIAGNOSTICS',
    SportObject = 'SPORT_OBJECT',
}